import axios from "axios";

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api/cannedmessages/`;

// Create canned message
const createCannedMessage = async (messageData) => {
    const response = await axios.post(API_URL, messageData, {
        withCredentials: true
    });
    return response.data;
};

// Get all canned messages
const getCannedMessages = async (params = {}) => {
    const queryString = new URLSearchParams(params).toString();
    const url = queryString ? `${API_URL}?${queryString}` : API_URL;

    const response = await axios.get(url, {
        withCredentials: true
    });
    return response.data;
};

// Get canned message by ID
const getCannedMessageById = async (id) => {
    const response = await axios.get(API_URL + id, {
        withCredentials: true
    });
    return response.data;
};

// Update canned message
const updateCannedMessage = async (id, messageData) => {
    const response = await axios.put(API_URL + id, messageData, {
        withCredentials: true
    });
    return response.data;
};

// Delete canned message
const deleteCannedMessage = async (id) => {
    const response = await axios.delete(API_URL + id, {
        withCredentials: true
    });
    return response.data;
};

const cannedMessageService = {
    createCannedMessage,
    getCannedMessages,
    getCannedMessageById,
    updateCannedMessage,
    deleteCannedMessage,
};

export default cannedMessageService;
